import { FontSize } from '../../types/Camera/FontSize';

export const FontSizeController = (props: FontSize) => {
  return (
    <>
      <div className="my-2 flex w-full flex-row justify-between">
        <button
          id="smaller-text"
          onClick={() => {
            props.setTextSize(props.textSize - 2);
          }}
        >
          Smaller
        </button>

        <input
          type="range"
          min="12" // CAUTION: The getTextSizeAdjustedBottom function in the TeleprompterText component relies on these values
          max="60" // IF EITHER OF THESE VALUES CHANGE, THIS FUNCTION WILL NEED TO BE UPDATED
          value={props.textSize}
          className="slider scale-[1.5]"
          id="text-size-slider"
          onChange={(e) => props.setTextSize(parseInt(e.target.value))}
          disabled={props.scrolling}
        />
        <button
          id="bigger-text"
          onClick={() => {
            props.setTextSize(props.textSize + 4);
          }}
        >
          Bigger
        </button>
      </div>
    </>
  );
};
